'use strict';

var angular = require('angular'),
    FooterController = require('./footer.ctrl');

module.exports = angular.module('App.footer', ['App'])
    .controller('FooterController', FooterController);